import { useSelector } from "react-redux";
import useOrderType from "../../hooks/useOrderType";
import { ToastMessage } from "./ToastMessage";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import config from "../../utils/globalConfig";

const ConfigurationCheck = ({ message, buttonLabelCode, confirmFunction }) => {
  const [notAllowedMessage, setNotAllowedMessage] = useState(null);

  const { customer } = useSelector((state) => state.yodaCustomer);
  const { order, configuration } = useSelector((state) => state.yodaOrders);

  const { customerId, orderId } = useParams();
  const { isReorderEnabled, isReorderEnabledForOrder, isSwapEnabledForOrder } =
    useOrderType();

  const localStorageCustomer = localStorage.getItem("selectedCustomer");

  useEffect(() => {
    if (
      customerId &&
      !isReorderEnabled &&
      configuration?.length &&
      customer &&
      customerId == customer?.id
    ) {
      setNotAllowedMessage(message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReorderEnabled, message, configuration, customerId, customer]);

  useEffect(() => {
    if (
      orderId &&
      configuration?.length &&
      order?.status === "Draft" &&
      localStorageCustomer == order?.stakeholderId
    ) {
      if (
        !isReorderEnabledForOrder(order) ||
        (order?.orderType?.id === config.ORDER_TYPE_SWAP &&
          !isSwapEnabledForOrder(order))
      ) {
        setNotAllowedMessage(message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!isReorderEnabledForOrder, order, message, configuration]);

  return (
    <>
      <ToastMessage
        message={notAllowedMessage}
        {...{ buttonLabelCode, confirmFunction }}
      />
    </>
  );
};

export default ConfigurationCheck;
